import { request } from 'axios/request';
import { WEB_URL_ACTIONS } from 'constants/liveCommerceConstants/webUrl';

const pending = () => ({
  type: WEB_URL_ACTIONS.PENDING,
});

const rejected = (error) => ({
  type: WEB_URL_ACTIONS.REJECTED,
  error: error,
});

const fulfilled = (response) => ({
  type: WEB_URL_ACTIONS.FULFILLED,
  response: response,
});

export const fetchWebUrl = () => (dispatch) => {
  dispatch(pending());
  request({
    url: '/omnitron/applications/?application_type=live-commerce&is_active=true',
    method: 'get',
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/liveCommerceActions/webUrl.js